<template>
  <div class="min-h-screen bg-gray-900 text-white">
    <router-view />
  </div>
</template>


<script>
export default {
  name: "App",
};
</script>

<style>
/* Global styles */
body {
  font-family: 'Inter', sans-serif;
}
</style>
